import { makeStyles, theme } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()(() => ({
  quotasTitle: {
    paddingRight: theme.spacing(0.125)
  }
}))

export default useStyles
